import styled from "styled-components";

const Badge = styled.span`
  background-color: red;
  border-radius: 8px;
  font-weight: bold;
  color: white;
  font-size: 12px;
  min-width: 15px;
  height: 15px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export default Badge;
